import React, { useLayoutEffect } from 'react';
import Services from './Services';
import SEO from './SEO';

const ServicesPage: React.FC = () => {
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-diwan-900">
            <SEO
                title="Our Services"
                description="We offer comprehensive interior design, furniture manufacturing, and restoration services."
                url="/services"
            />
            {/* Navbar Placeholder */}
            <div className="h-24 md:h-32 w-full"></div>

            <Services />
        </div>
    );
};

export default ServicesPage;
